import request from "./axiosConfig";
/**
 * 获取当前页面浏览量
 */
export const getPageview = () => {
  return request({
    url: "/interface/pageview/getpageview",
    method: "get",
  });
};
/**
 * 增加页面浏览量（保存）
 */
export const savePageview = () => {
  return request({
    url: "/interface/pageview/savepageview",
    method: "get",
  });
};

/**
 * 上报页面浏览记录（含IP、地域、页面名）
 */
export const reportPageView = (data) => {
  return request({
    url: "/interface/pageview/report",
    method: "post",
    data: data,
  });
};
